<span class="partner-information">
  darf nicht mit {{partner}} wichteln
  <a href="{{path}}" class="destroy" data-method="delete" data-remote="true" rel="nofollow">entfernen</a>
</span>